import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import * as Chart from 'chart.js';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { BarCharDataAlertChannel } from 'src/app/modules/dashboard/utils/line_chart_data';

@Component({
  selector: 'alert-by-channel',
  templateUrl: './alert-by-channel.component.html',
  styleUrls: ['./alert-by-channel.component.scss'],
})
export class AlertByChannelComponent implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    private readonly resumeService: ResumeService
  ) {}
  isEmpty;
  ngOnInit() {
    this.getDataAlertByAnalysChannel();
  }
  async getDataAlertByAnalysChannel() {
    await this.resumeService.typeAlertChannel({}).subscribe((res) => {
      this.barsData(res);
    });
  }
  bar: Chart;
  barsData(data: BarCharDataAlertChannel) {
    if (this.bar) {
      this.bar.destroy();
    }
    var canvas = document.getElementById('barChannel') as HTMLCanvasElement;
    var parent = document.getElementById('alertChannel');
    canvas.width = parent.offsetWidth;
    this.bar = new Chart('barChannel', {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [
          {
            data: data.amount,
            backgroundColor: [
              '#005dd0',
              '#2e8cef',
              '#30c5ff',
              '#f6a506',
              '#f58500',
              '#ff5733',
              '#ff0055',
            ],
          },
        ],
      },
      options: {
        // indexAxis: 'y',
        elements: {
          // bar: {
          //   borderWidth: 2,
          // }
        },
        responsive: true,

        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var value =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value.toString();
            },
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false, // Remove vertical grid lines
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                drawBorder: false, // Remove horizontal grid border
                display: true, // Keep horizontal lines
              },
              ticks: {
                beginAtZero: true,
                min: 0, // Y axis always starts at 0
                precision: 0, // Integer ticks only (ignored if stepSize is set)
              },
            },
          ],
        },
      },
    });
  }
}
